import TopBar from '@/pages/home/components/TopBar';
import Navbar from '@/pages/home/components/Navbar';
import Hero from '@/pages/home/components/Hero';
import EntrySection from '@/pages/home/components/EntrySection';
import AddressSection from '@/pages/home/components/AddressSection';
import AppDownloadSection from '@/pages/home/components/AppDownloadSection';
import SafetySection from '@/pages/home/components/SafetySection';
import FeedSection from '@/pages/home/components/FeedSection';
import FaqSection from '@/pages/home/components/FaqSection';
import CtaBand from '@/pages/home/components/CtaBand';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <TopBar />
      <Navbar />
      <main>
        <Hero />
        <EntrySection />
        <AddressSection />
        <AppDownloadSection />
        <SafetySection />
        <FeedSection />
        <FaqSection />
        <CtaBand />
      </main>
      <Footer />
    </div>
  );
}